module.exports = __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/conlallave_mobile.add246a7.svg";